import Dialog from '../../../../../global/Mui/Dialog';
import Check from '../../../../../images/check-green-white.svg';
import Send from '../../../../../images/icon-send.svg';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../../../global/Button';
import { getNextButtonStyles } from '../../../../../utils/tbbRegistration';
import { getTrackerId, POSTHOG_CAPTURE_ATTRIBUTES, TRACKER_IDS } from '../../../../../config/tracker';

import './TbbRegisteredDialog.scss';

const {
  tbb: {
    lastStep: {
      registrationSuccessful: trackerRegistrationSuccessful,
    },
  },
} = TRACKER_IDS;

export default function TbbRegisteredDialog({
  isOpen,
  onClose,
  recyclingProductType,
  storeConfig,
  shippingMethodUid,
}) {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <div className="TbbRegisteredDialog">
        <div>
          <img src={Check} alt="check" />
        </div>
        <div className="TbbRegisteredDialog__content">
          <div className="TbbRegisteredDialog__content--title">
            {storeConfig?.registerTbbFlow?.shipingMethodStep?.[shippingMethodUid] || `${recyclingProductType} REGISTERED AND
                READY FOR DROP OFF!`}
          </div>
          <div className="TbbRegisteredDialog__content--mesages">
            <div className="TbbRegisteredDialog__content--mesages--message">
              <img src={Send} alt="send" />
              {' '}
              Label sent via email
            </div>
          </div>
          <Button
            type={BUTTON_TYPE.QUATERNARY}
            size={BUTTON_SIZE.LARGE}
            onClick={onClose}
            style={getNextButtonStyles(storeConfig)}
            trackerProps={{
              [POSTHOG_CAPTURE_ATTRIBUTES.TRACKER_ID]: getTrackerId(trackerRegistrationSuccessful),
            }}
          >
            CONTINUE
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
